import { lazy } from "react"
import { RouteProps } from "../features.types"

const PriceEstimateController = lazy(
  () => import("./price-estimate-controller")
)
const PriceEstimateHome = lazy(() => import("./price-estimate"))
// define route constant
export const ESTIMATE_PRICE_ROUTE = "estimate-prices"

//define routes
export const PriceEstimate: RouteProps[] = [
  {
    path: `${ESTIMATE_PRICE_ROUTE}`,
    Component: PriceEstimateController,
    children: [
      {
        index: true,
        Component: PriceEstimateHome,
      },
    ],
  },
]
